module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-7-d6bb21a86d72af71e969f26496f5b25d.webp";